import { BRAND_COPY, FREE_TEXT_MAX_LENGTH } from '@fyf/shared';

import { CharacterCounter } from '../components/CharacterCounter.js';
import { ScreenLayout } from '../components/ScreenLayout.js';
import { StepIndicator } from '../components/StepIndicator.js';
import { SubmitButton } from '../components/SubmitButton.js';
import { useCaptureDispatch, useCaptureState } from '../context/CaptureFlowContext.js';
import { useRotatingPlaceholder } from '../hooks/useRotatingPlaceholder.js';
import { validateFreeText } from '../utils/validate.js';

const { spark } = BRAND_COPY.screens;

export function SparkScreen() {
  const { freeText } = useCaptureState();
  const dispatch = useCaptureDispatch();
  const placeholder = useRotatingPlaceholder(spark.placeholders);

  const error = validateFreeText(freeText);
  const canProceed = !error;

  function handleNext() {
    if (canProceed) {
      dispatch({ type: 'SET_SCREEN', payload: 'contact' });
    }
  }

  return (
    <ScreenLayout>
      <StepIndicator label={spark.stepLabel} currentStep={3} />
      <h1 className="text-[32px] font-['Lora',serif] text-center mb-4">
        What change do you
        <br />
        want to <span className="text-brand-gradient italic">ignite</span>?
      </h1>
      <p className="font-['DM_Sans',sans-serif] text-base text-white text-center mb-10">
        Name a shift in your life, your work,
        <br />
        or the world around you.
      </p>
      <textarea
        id="free-text"
        value={freeText}
        onChange={(e) => dispatch({ type: 'SET_FREE_TEXT', payload: e.target.value })}
        placeholder={placeholder}
        maxLength={FREE_TEXT_MAX_LENGTH}
        rows={4}
        className="w-full max-w-md px-3 py-2 rounded-xl border border-[var(--gray-border)] text-white placeholder-[#757575] focus:border-[#f97216] focus:outline-none resize-none font-['DM_Sans',sans-serif]"
        style={{ backgroundImage: 'var(--glass-gradient)' }}
        aria-label={spark.question}
      />
      <div className="w-full max-w-md">
        <CharacterCounter current={freeText.length} />
      </div>
      <div className="mt-10 w-full max-w-md">
        <SubmitButton label={spark.button} onClick={handleNext} disabled={!canProceed} />
      </div>
    </ScreenLayout>
  );
}
